module["exports"] = [
  "driver",
  "protocol",
  "bandbreedte",
  "paneel",
  "microchip",
  "programma",
  "port",
  "kaart",
  "array",
  "verbinding",
  "draad",
  "stekker",
  "systeem",
  "sensor",
  "firewall",
  "harde schijf",
  "pixel",
  "alarm",
  "voeding",
  "monitor",
  "toepassing",
  "zender",
  "bus",
  "stroomkring",
  "condensator",
  "matrix"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl/hacker/noun.js
// module id = 3296
// module chunks = 1610